import { oc } from '@orpc/contract';
import { listEstimatesInputSchema, listEstimatesOutputSchema } from '../schemas/estimates.schemas.js';
/** Every estimate stays here, whether or not it became a purchase — so no status is hidden by default. */
export const listEstimatesContract = oc
    .route({
    method: 'GET',
    path: '/estimates',
    tags: ['Estimates'],
    summary: 'List the estimates of the caller’s tenant',
})
    .input(listEstimatesInputSchema)
    .output(listEstimatesOutputSchema);
//# sourceMappingURL=list-estimates.contract.js.map